import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ImagenXFicha } from '../models/imagenesXFicha.interface';
import { User } from '../models/user.interface';
import { apiUrl } from './utils.service';

@Injectable({
providedIn: 'root'
})
export class UsersService {
private baseUrl =  apiUrl.production+'users';

headers = new HttpHeaders();


constructor(private http: HttpClient) { 
    this.headers.append('Content-Type', 'application/json');
}
verify(user: User) {
    return this.http.post(`${this.baseUrl}/verify`, user);
}



}
